import React from 'react';
import Status from 'components/Status';
import { EStatuses } from 'components/Status/types';

interface IFallbackProps {
  error: Error;
}

const Fallback: React.FC<React.PropsWithChildren<IFallbackProps>> = ({ error }) => {
  let additionalDescription = '';

  if (process?.env?.NODE_ENV === 'test') {
    additionalDescription = error.message;
  }

  return (
    <Status
      status={EStatuses.InternalServerError}
      additionalDescription={additionalDescription}
    />
  );
};

export default Fallback;
